<template>
    <v-dialog 
        v-model="dialog" 
        width="85vw" 
        persistent
    >
        <v-card>
            <v-card-title class="d-flex align-center justify-space-between">
                <div class="d-flex flex-column">
                    <span>{{ studentName }}</span>
                    <span class="text-caption font-weight-light">Student ID #: {{ studentId }}</span>
                </div>
                
                <v-btn
                    icon
                    @click="close"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>

            <v-divider />

            <v-card-text>
                <v-data-table
                    :headers="headers"
                    :items="subjectGroupings"
                    fixed-header
                    height="400"
                    hide-default-footer
                    class="mt-4"
                >
                    <template v-slot:item="props">
                            <tr>
                                <td>{{ props.item.choice }}</td>
                                <td>
                                    <div class="d-flex flex-column">
                                        <v-select
                                            v-model="studentSubjectChoices[props.item.choice][1]"
                                            :items="props.item.group_1"
                                            item-text="title"
                                            item-value="subject_id"
                                            outlined
                                            dense
                                            hide-details
                                            disabled
                                            class="mt-3"
                                        ></v-select>
                                        <v-chip label class="my-3">Exam Mark: {{ subjectExamMark(studentSubjectChoices[props.item.choice][1]) }}</v-chip>
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column">
                                        <v-select
                                            v-model="studentSubjectChoices[props.item.choice][2]"
                                            :items="props.item.group_2"
                                            item-text="title"
                                            item-value="subject_id"
                                            outlined
                                            dense
                                            hide-details
                                            disabled
                                        ></v-select>
                                        <v-chip label class="my-3">Exam Mark: {{ examMarks[props.item.choice][2] }}</v-chip>    
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column">
                                        <v-select
                                            v-model="studentSubjectChoices[props.item.choice][3]"
                                            :items="props.item.group_3"
                                            item-text="title"
                                            item-value="subject_id"
                                            outlined
                                            dense
                                            hide-details
                                            disabled
                                        ></v-select>
                                        <v-chip label class="my-3">Exam Mark: {{ examMarks[props.item.choice][3] }}</v-chip>    
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column">
                                        <v-select
                                            v-model="studentSubjectChoices[props.item.choice][4]"
                                            :items="props.item.group_4"
                                            item-text="title"
                                            item-value="subject_id"
                                            outlined
                                            dense
                                            hide-details
                                            disabled
                                        ></v-select>
                                        <v-chip label class="my-3">Exam Mark: {{ examMarks[props.item.choice][4] }}</v-chip>    
                                    </div>
                                </td>
                                <td>
                                    <div class="d-flex flex-column">
                                        <v-select
                                            v-model="studentSubjectChoices[props.item.choice][5]"
                                            :items="props.item.group_5"
                                            item-text="title"
                                            item-value="subject_id"
                                            outlined
                                            dense
                                            hide-details
                                            disabled
                                        ></v-select>
                                        <v-chip label class="my-3">Exam Mark: {{ examMarks[props.item.choice][5] }}</v-chip>

                                    </div>
                                </td>
                            </tr>
                    </template>   
                </v-data-table>
            </v-card-text>

            <v-card class="my-3 pb-3" flat>
                <v-card-title class="pb-0">Subjects Assigned</v-card-title>
                <v-card-text>
                    <div style="border: 2px solid red">
                        <v-data-table
                            :headers="headers"
                            :items="subjectsAssigned"
                            hide-default-footer
                            height="120"
                        >
                            <template v-slot:header.choice>
                               
                            </template>
                            <template v-slot:item="props">
                                    <tr>
                                        <td></td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectAssignment[1]"
                                                :items="props.item.group_1"
                                                item-text="title"
                                                item-value="subject_id"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectAssignment[2]"
                                                :items="props.item.group_2"
                                                item-text="title"
                                                item-value="subject_id"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectAssignment[3]"
                                                :items="props.item.group_3"
                                                item-text="title"
                                                item-value="subject_id"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectAssignment[4]"
                                                :items="props.item.group_4"
                                                item-text="title"
                                                item-value="subject_id"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </td>
                                        <td>
                                            <v-select
                                                v-model="studentSubjectAssignment[5]"
                                                :items="props.item.group_5"
                                                item-text="title"
                                                item-value="subject_id"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </td>
                                    </tr>
                            </template>   
                        </v-data-table>
                    </div>
                </v-card-text>
            </v-card>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn color="primary" @click="update" class="mr-3">Update Assignment</v-btn>
                <v-btn depressed @click="close" class="mr-3">Close Record</v-btn>
            </v-card-actions>

            <v-overlay :value="overlay" absolute>
                <v-progress-circular 
                    indeterminate 
                    size="64"
                ></v-progress-circular>
            </v-overlay>
        </v-card>
        
    </v-dialog>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

    export default {
        name: 'CSECSubjectSelectionStudent',

        props: {
            studentRecord: Object,
            display: Boolean,
        },

        mounted () {
            //this.initialize();
        },

        watch: {
            display: function(val) {
                this.dialog = val;
            },

            studentRecord: function(val) {
                if(val) this.initialize();
            }
        },

        computed: {
            studentName () {
                if(!this.studentRecord) return '';
                return this.studentRecord.first_name + ' ' + this.studentRecord.last_name
            },

            studentId () {
                if(!this.studentRecord) return '';
                return this.studentRecord.student_id
            },

            
        },

        data: function() {
            return {
                dialog: false,
                headers: [
                    { text: 'Choice', value: 'choice', width: '70', sortable: false },
                    { text: 'Group 1', value: 'group_1', sortable: false },
                    { text: 'Group 2', value: 'group_2', sortable: false },
                    { text: 'Group 3', value: 'group_3', sortable: false },
                    { text: 'Group 4', value: 'group_4', sortable: false },
                    { text: 'Group 5', value: 'group_5', sortable: false },
                ],
                subjectGroupings: [],
                overlay: false,
                studentSubjectChoices: {},
                defaultSubjectChoices: {
                    1: { 1: null, 2: null, 3: null, 4: null, 5: null },
                    2: { 1: null, 2: null, 3: null, 4: null, 5: null },
                    3: { 1: null, 2: null, 3: null, 4: null, 5: null },
                },
                subjectsAssigned: [],
                studentSubjectsAssigment:{},
                examMarks: {},
                testMarks: {},
            }
        },

        methods: {
            ...mapActions({
                getSubjectGroups: 'csecSubjectSelection/getSubjectGroups',
                getStudentSubjectChoices: 'csecSubjectSelection/getStudentSubjectChoices',
                getStudentSubjectAssignment: 'csecSubjectSelection/getStudentSubjectAssignment',
                postStudentSubjectAssignment: 'csecSubjectSelection/postStudentSubjectAssignment',
            }),

            ...mapMutations({
                setStudentSubjectAssignment: 'csecSubjectSelection/setStudentSubjectAssignment',
            }),

            async initialize () {
                this.overlay = true;
                this.studentSubjectChoices = JSON.parse(JSON.stringify(this.defaultSubjectChoices));
                this.studentSubjectAssignment = JSON.parse(JSON.stringify(this.defaultSubjectChoices[1]));
                this.examMarks = JSON.parse(JSON.stringify(this.defaultSubjectChoices));
                try{
                    const [
                        { data: dataSubjectGroups },
                        { data: dataStudentSubjectChoices },
                        { data: dataStudentSubjectAssignment },
                    ] = await Promise.all([
                        this.getSubjectGroups(),
                        this.getStudentSubjectChoices(),
                        this.getStudentSubjectAssignment()
                    ]);
                    this.mapStudentSubjectChoices(dataStudentSubjectChoices);
                    this.mapSubjectGroupings(dataSubjectGroups);
                    this.mapStudentSubjectsAssignment(dataStudentSubjectAssignment);
                } catch (error) {
                    error.response ? console.log(error.response) : console.log(error);
                } finally {
                    this.overlay = false;
                }
            },

            mapSubjectGroupings(subjectGroups) {
                for(let i = 1; i <= 3; i++){
                    this.subjectGroupings.push({
                        choice: i,
                        group_1: subjectGroups.filter(item => item.subject_group == 1),
                        group_2: subjectGroups.filter(item => item.subject_group == 2),
                        group_3: subjectGroups.filter(item => item.subject_group == 3),
                        group_4: subjectGroups.filter(item => item.subject_group == 4),
                        group_5: subjectGroups.filter(item => item.subject_group == 5),
                    })

                    if(i == 1){
                        this.subjectsAssigned.push({
                            choice: i,
                            group_1: subjectGroups.filter(item => item.subject_group == 1),
                            group_2: subjectGroups.filter(item => item.subject_group == 2),
                            group_3: subjectGroups.filter(item => item.subject_group == 3),
                            group_4: subjectGroups.filter(item => item.subject_group == 4),
                            group_5: subjectGroups.filter(item => item.subject_group == 5),
                        })
                    }
                }
            },

            mapStudentSubjectChoices(data) {
                for(let i = 1; i <=3; i++){
                    for(let j = 1; j <= 5; j++){
                        //this.studentSubjectChoices[i][j] = null;
                        if(data.filter(choice => choice.choice == i && choice.subject_group == j).length > 0){
                            let subjectId = data.filter(choice => choice.choice == i && choice.subject_group == j)[0].subject_id;
                            let examMark = data.filter(choice => choice.choice == i && choice.subject_group == j)[0].exam_mark;
                            this.studentSubjectChoices[i][j] = subjectId;
                            this.examMarks[i][j] = examMark;
                            this.testMarks[subjectId] = examMark;
                        } 
                    }
                }
            },

            mapStudentSubjectsAssignment(data) {
                for(let j = 1; j <= 5; j++){
                    if(data.filter(choice => choice.subject_group == j).length > 0){
                        this.studentSubjectAssignment[j] = data.filter(choice => choice.subject_group == j)[0].subject_id;
                    } 
                }
            },

            close () {
                this.$emit('close');
                this.dialog = false;
                this.studentSubjectChoices = JSON.parse(JSON.stringify(this.defaultSubjectChoices));
                this.studentSubjectAssignment = JSON.parse(JSON.stringify(this.defaultSubjectChoices[1]));
                this.subjectGroupings = [];
                this.subjectsAssigned = [];
            },

            async update () {
                this.setStudentSubjectAssignment(this.studentSubjectAssignment);
                try{
                    const response = await this.postStudentSubjectAssignment();
                    console.log(response);
                } catch (error) {
                    error.response ? console.log(error.response) : console.log(error);
                }
            },

            subjectExamMark(subjectId){
                return this.testMarks[subjectId] ?? "---";
            }

           
        }
    }
</script>